/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class Thumbnails<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags thumbnail-controller
   * @name GetThumbnail
   * @request GET:/thumbnails/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  getThumbnail = (documentId: string, params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/thumbnails/${documentId}`,
      method: "GET",
      secure: true,
      format: "blob",
      ...params,
    });
}
